import { Component, Input, SimpleChanges, OnDestroy } from '@angular/core';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts';
import { HttpClient } from '@angular/common/http';
import { LineOrTrendedService } from '../../line-or-trended.service';
import { Observable, Subscription } from 'rxjs';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { SignificanceService } from 'src/app/common/services/significance.service';

@Component({
  selector: 'app-line-or-trend-chart1-custom',
  template: `<div [id]="'chart-container'" [style]="'height:26rem'"></div>`
})
export class Lineortrendchart1ComponentCustom implements OnDestroy {
  @Input() brandSelected:any="";
  @Input() metricSelected: any = "";
  data: any;
  LineChartData: any[] = [];
  ChartProperties: any;
  configuredProperties: any;
  categoriesList: any;
  updateCategoryName: any = [];
  colorCodeList: any[] = [];
  seriesData: any[] = [];
    isAudienceSnapshot :boolean = false;
  chart: any;
  custom: any[] = [];
  event: any;
  changeValue: any[] = [];
  significanceValue: any;
  sampleSizeValues: any[] = [];
  actualDataValue: any[] = [];
  chartCategories: any;
  samplesizeConstantValue = 1000;
  chartMinAxis: any;
  chartMaxAxis: any;
  showLowSample: any;
  tickInterval = 10;
  tickIntervalForStacking = 50;
  @Input() trendData: any;
  @Input() id: any;
  @Input() Top10Toggle: any=false;
  @Input() DataLabelOn: any;
  @Input() isOutput: any;
  // store global color map from SnapshotService
  globalColorMap: { [key: string]: string } = {};
  hasCustomMetricIndex = false;
hasCustomMetricSignificance = false;
hasCustomMetricPercentage = false;
  
  constructor(public http: HttpClient, public LineTrendService: LineOrTrendedService, private _customSnapshotService: CustomsnapshotService, private _configService: SnapshotService,private significanceService: SignificanceService) { }
  @Input() height: any = "24em";
  ngOnInit(): void {
        this.isAudienceSnapshot =
    this._configService.selectedSnapshotType
      ?.toLowerCase()
      ?.includes('audience');
    // Try to get the current global color map synchronously first
    const currentGlobalColorMap = this._configService.getGlobalColorMap();
    if (currentGlobalColorMap && Object.keys(currentGlobalColorMap).length > 0) {
      this.globalColorMap = currentGlobalColorMap;
    }
    
    // subscribe to global color map from service so we pick up colors even if set after init
    this.serviceSubscriptions.add(
      this._configService.globalColorMap$.subscribe((map) => {
        if (map && Object.keys(map).length > 0) {
          this.globalColorMap = map;
          // re-prepare series and redraw to apply new colors
          try {
            this.prepareSeriesDataForChart();
            if (this.chart) this.plotLineChart('chart-container');
          } catch (e) {}
        }
      })
    );
    if (this.isOutput) {
      if (this.trendData?.customizationProperties) {
        this.configuredProperties = JSON.parse(this.trendData.customizationProperties);
      }
      this.applyCustomMetricExtensions();
      this.updatesig();
    }
    else {
      //this.categoriesList = ["Oct'2023", "Nov'2023", "Dec'2023", "Jan'2024", "Feb'2024"]
      this.http.get<any>('assets/Data/lineChartData.json').subscribe(jsonData => {
        this.data = jsonData[0];
        this.LineChartData = jsonData[0].data;
        this.ChartProperties = jsonData[0].properties[0];
        this.ChartProperties.decimalRoundOff = 2;
        this.ChartProperties.legendPosition = "bottom"
        this.colorCodeList = jsonData[0].ColorCodes;
        this.plotLineChart('chart-container');
      }, error => {
        console.error('Error fetching data:', error);
      });
    }
  }
private applyCustomMetricExtensions(): void {

  const metrics = this.trendData?.metric?.[0]?.metric_value || [];

  this.hasCustomMetricIndex = false;
  this.hasCustomMetricSignificance = false;
  this.hasCustomMetricPercentage = false;

  metrics.forEach((metric: any) => {

    const extensions = metric.extensionOptions || [];

    if (
      extensions.some(
        (e: any) => e.id === 'index' && e.selected
      )
    ) {
      this.hasCustomMetricIndex = true;
    }

    if (
      extensions.some(
        (e: any) => e.id === 'significance' && e.selected
      )
    ) {
      this.hasCustomMetricSignificance = true;
    }

    if (
      extensions.some(
        (e: any) => e.id === 'percentageSymbol' && e.selected
      )
    ) {
      this.hasCustomMetricPercentage = true;
    }
  });
}
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = '';
  private subscriptions: Subscription = new Subscription();
  private serviceSubscriptions: Subscription = new Subscription();

  ngOnDestroy(): void {
    try {
      if (this.chart) { this.chart.destroy(); this.chart = null; }
         this.subscriptions.unsubscribe();
    } catch (e) {}
    try {
      this.serviceSubscriptions.unsubscribe();
    } catch (e) {}
  }
  updatesig() {
    this.Sig_LowerLimt = this.significanceService.getSigLowerLimit(this.DefaultConfidenceLevel, true);
    this.Sig_UpperLimt = this.significanceService.getSigUpperLimit(this.DefaultConfidenceLevel, true);

      
            
    this.preparemainChartData(this.trendData);
    this.subscriptions.add(
      this._configService.confedenceValue.subscribe((value) => {
        this.DefaultConfidenceLevel = value;
      }));
    this.subscriptions.add(
      this._configService.significanceValue.subscribe((value) => {
        this.significanceValue = value;
      }));
    this.subscriptions.add(
      this.http.get<any>('assets/Data/lineChartData.json').subscribe(
        (jsonData) => {
          this.ChartProperties = jsonData[0].properties[0];
          const defaultProps = jsonData[0].properties[0];
          this.ChartProperties = this.configuredProperties != undefined ? { ...defaultProps, ...this.configuredProperties } : defaultProps;
          this.colorCodeList=this.LineTrendService.color1;
         // this.colorCodeList = jsonData[0].ColorCodes;
          // this.ChartProperties.datalabelStyle =
          //   this.significanceValue == 'None' ? 'datalabel' : 'sigChange';
          // this.ChartProperties.datalabelStyle = this._configService
          //   .isIndexSelected
          //   ? 'index'
          //   : this.ChartProperties.datalabelStyle;
          if (this.hasCustomMetricSignificance) {
            this.ChartProperties.datalabelStyle = 'datalabel';
          }
          else {
            this.ChartProperties.datalabelStyle =
              this.significanceValue == 'None'
                ? 'datalabel'
                : 'sigChange';
          }

          if (
            this._configService.isIndexSelected &&
            !this.hasCustomMetricIndex
          ) {
            this.ChartProperties.datalabelStyle = 'index';
          }
          this.plotLineChart('chart-container');
        },
        (error) => {
          console.error('Error fetching data:', error);
        }
      ));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['trendData'] && this.isOutput && changes['trendData'].currentValue?.customizationProperties) {
      this.configuredProperties = JSON.parse(changes['trendData'].currentValue.customizationProperties);
    }
    this.applyCustomMetricExtensions();
    this.updatesig();
    // Do NOT call ngOnInit() here — updatesig() already handles redraw,
    // and calling ngOnInit() would create duplicate subscriptions.
  }
  chartMainData: any = [];
  // True for audience (Multi-Cohort) snapshots where the trendline-2 dropdowns drive
  // which audience/metric series are rendered. Reads the service directly so it is
  // correct even on the first ngOnChanges (which runs before ngOnInit).
  get isAudienceCohortChart(): boolean {
    return !!this._configService.selectedSnapshotType?.toLowerCase().includes('audience');
  }
  // Snapshot label logic: show only the unmatched (distinguishing) portion of an
  // audience label when the leaf level is shared across audiences, otherwise show
  // the full leaf. Mirrors the logic used elsewhere in the Snapshot module.
  getAudienceDisplayLabel(colChild: string, allColChilds: string[]): string {
    if (!colChild || !colChild.includes('|')) { return colChild; }
    const parts = colChild.split('|').map((p: string) => p.trim());
    const last = parts[parts.length - 1];
    return last;
  }

  private hasMultipleMetricGroups(rowChilds: string[]): boolean {
    const groups = new Set(
      (rowChilds || []).map((rc: string) => {
        if (!rc) { return ''; }
        const firstPipe = rc.indexOf('|');
        return firstPipe > -1 ? rc.substring(0, firstPipe).trim() : '';
      })
    );
    return groups.size > 1;
  }

  private getMetricGroupAwareLabel(rowChild: string, showGroup: boolean): string {
    if (!rowChild || !rowChild.includes('|')) { return rowChild; }
    if (showGroup) { return rowChild; }
    const firstPipe = rowChild.indexOf('|');
    return rowChild.substring(firstPipe + 1).trim();
  }
  preparemainChartData(data: any) {
    this.Top10Toggle=false; // setting this as of now as Top10Toggle is  not implemented
    let i = 0;
    let isTotalBase =  this._configService.finalLeftPanelSubmitObject.isTotalBase;
    this.chartMainData = [];
    // Keep the trendline-2 metric/audience selections for audience snapshots; only clear
    // them for non-audience, non-multi snapshots where they are not applicable.
    if(!this.isAudienceCohortChart && !this._configService.selectedSnapshotType.toLowerCase().includes("multi")){
      this.metricSelected="";
      this.brandSelected="";
    }
    // For "All Metrics for Selected Audience" in a Multi-Cohort snapshot, collect every
    // metric (rowChild) rendered for the chosen audience so the unmatched-portion label
    // logic can be applied across metrics.
    const audienceMetricRowChilds: string[] = (this.isAudienceCohortChart && this.brandSelected != "")
      ? Array.from(new Set(
          (data.metric || []).flatMap((lev1: any) =>
            (lev1.metric_value || []).flatMap((lev2: any) =>
              (lev2.data || [])
                .filter((d: any) => d.colChild == this.brandSelected)
                .map((d: any) => d.rowChild)
            )
          )
        )) as string[]
      : [];
    const brandMetricRowChilds: string[] = (!this.isAudienceCohortChart && this.brandSelected != "")
      ? Array.from(new Set(
          (data.metric || []).flatMap((lev1: any) =>
            (lev1.metric_value || []).flatMap((lev2: any) =>
              (lev2.data || [])
                .filter((d: any) => d.colChild == this.brandSelected)
                .map((d: any) => d.rowChild)
            )
          )
        )) as string[]
      : [];
    const brandMetricsHaveMultipleGroups = this.hasMultipleMetricGroups(brandMetricRowChilds);

    data.metric.forEach((lev1: any) => {
      lev1.metric_value.forEach((lev2: any, index: number) => {
        if (
          this.Top10Toggle == false ||
          (this.Top10Toggle == true && index < 10)
        ) {
          if (this.metricSelected != "") {
            const ConditionCheck = lev2.option==null ? lev2.metricName : lev2.option; 
          const rowChildMatch = lev2.data?.some((d: any) => d.rowChild === this.metricSelected);
          if (ConditionCheck == this.metricSelected || rowChildMatch) {
              // For audience cohort, collect the audiences (colChilds) rendered for this
              // metric so the unmatched-portion label logic can be applied consistently.
              const audienceColChilds = this.isAudienceCohortChart
                ? Array.from(new Set(
                    lev2.data
                      .filter((d: any) => d.rowChild?.includes(this.metricSelected))
                      .map((d: any) => d.colChild)
                  )) as string[]
                : [];
                const hasPercentageExtension =
  lev2.extensionOptions?.some(
    (e: any) =>
      e.id === 'percentageSymbol' &&
      e.selected
  ) || false;
              lev2.data.forEach((dataArr: any) => {
              if(dataArr.rowChild.includes(this.metricSelected) && dataArr.data != null){
                let d1 = {
                  'Series Name':  this.isAudienceCohortChart
                    ? (dataArr.colChild
                        ? this.getAudienceDisplayLabel(dataArr.colChild, audienceColChilds)
                        : (dataArr.rowChild || ''))
                    : (dataArr.colChild
                        ? (dataArr.colChild.includes('|') ? dataArr.colChild.split('|')[1] : dataArr.colChild)
                        : (dataArr.rowChild || '')),
                  'Category Name': dataArr?.lvl1Child?.replace(/^(Month|Year|Quarter)\|/, ''),
                  'Rounded Value':
                    dataArr.data == null
                      ? null
                      : dataArr.CalculationType?.toLowerCase() == 'share' ||
                        dataArr.CalculationType?.toLowerCase() == 'respgrp'
                        ? dataArr.data * 100
                        : dataArr.data,
                  'Value':
                    dataArr.CalculationType?.toLowerCase() == 'share' ||
                      dataArr.CalculationType?.toLowerCase() == 'respgrp'
                      ? dataArr.data * 100
                      : dataArr.data,
                  "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
                  "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
                  'Label':
                    dataArr.data == null
                      ? 'NA'
                      : dataArr.CalculationType?.toLowerCase() == 'share' ||
                        dataArr.CalculationType?.toLowerCase() == 'respgrp'
                        ? dataArr.data * 100
                        : dataArr.data,
                  'ChangeVs': isTotalBase ? dataArr.changeVsPY_Total :dataArr.changeVsPY_Answer,
                  'Significance': '-1',
                  'Sample size':  this._configService.baseSelected.toLowerCase() == 'total base'
                        ? dataArr.totalUnweightedBase
                        : dataArr.answerUnweightedBase,
                  'Significance2': '1',
                  'Category Image': 'Category_Image_1',
                  'isPercentage':
                    (dataArr.CalculationType?.toLowerCase() === "share" ||
                      dataArr.CalculationType?.toLowerCase() === "respgrp" ||
                      dataArr.CalculationType?.toLowerCase() === "meanpercentage"
                    )
                      ? true
                      : (hasPercentageExtension === true ? false : hasPercentageExtension === null ? false : true),
                  'Sig_LowerLimt': this.Sig_LowerLimt,
                  'Sig_UpperLimt': this.Sig_UpperLimt,
                   'color': dataArr.color,
                  "Significance_Value": isTotalBase ? dataArr.Significance_Total : dataArr.Significance_Answer,
                  'isAdditionalKPI': dataArr.isAdditionalKPI ?? false
                };
                this.chartMainData.push(d1);
              }
              });
            }
          }
          if(this.brandSelected !=""){
            const hasPercentageExtension =
  lev2.extensionOptions?.some(
    (e: any) =>
      e.id === 'percentageSymbol' &&
      e.selected
  ) || false;
            lev2.data.forEach((dataArr: any) => {
              if(dataArr.colChild==this.brandSelected && dataArr.data != null){
              let d1 = {
                'Series Name': this.isAudienceCohortChart
                  ? this.getAudienceDisplayLabel(dataArr.rowChild, audienceMetricRowChilds)
                  : this.getMetricGroupAwareLabel(dataArr.rowChild, brandMetricsHaveMultipleGroups),//.split("|").length>0?dataArr.rowChildsplit("|")[1]:dataArr.rowChild,
                'Category Name': dataArr.lvl1Child.replace(/^(Month|Year|Quarter)\|/, ''),
                'Rounded Value':
                  dataArr.data == null
                    ? null
                    : dataArr.CalculationType?.toLowerCase() == 'share' ||
                      dataArr.CalculationType?.toLowerCase() == 'respgrp'
                      ? dataArr.data * 100
                      : dataArr.data,
                'Value':
                  dataArr.CalculationType?.toLowerCase() == 'share' ||
                    dataArr.CalculationType?.toLowerCase() == 'respgrp'
                    ? dataArr.data * 100
                    : dataArr.data,
                "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
                "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
                'Label':
                  dataArr.data == null
                    ? 'NA'
                    : dataArr.CalculationType?.toLowerCase() == 'share' ||
                      dataArr.CalculationType?.toLowerCase() == 'respgrp'
                      ? dataArr.data * 100
                      : dataArr.data,
                'ChangeVs': isTotalBase ? dataArr.changeVsPY_Total :dataArr.changeVsPY_Answer,
                'Significance': '-1',
                     'Sample size':  this._configService.baseSelected.toLowerCase() == 'total base'
                        ? dataArr.totalUnweightedBase
                        : dataArr.answerUnweightedBase,
                'Significance2': '1',
                'Category Image': 'Category_Image_1',
                'isPercentage':
                  (dataArr.CalculationType?.toLowerCase() === "share" ||
                    dataArr.CalculationType?.toLowerCase() === "respgrp" ||
                    dataArr.CalculationType?.toLowerCase() === "meanpercentage"
                  )
                    ? true
                    : (hasPercentageExtension === true ? false : hasPercentageExtension === null ? false : true),
                'Sig_LowerLimt': this.Sig_LowerLimt,
                'Sig_UpperLimt': this.Sig_UpperLimt,
                'color': dataArr.color,
                "Significance_Value": isTotalBase ? dataArr.Significance_Total : dataArr.Significance_Answer,
                'isAdditionalKPI': dataArr.isAdditionalKPI ?? false
              };
              this.chartMainData.push(d1);
            }
            });
          }
          if(this.brandSelected=="" && this.metricSelected=="") {
            const _uniqueRowChilds = new Set((lev2.data || []).map((d: any) => d.rowChild).filter(Boolean));
            const _uniqueColChilds = new Set((lev2.data || []).map((d: any) => d.colChild).filter(Boolean));
            const _audienceAllSamePrefix = (this.isAudienceSnapshot && !this._configService.multiCohort && this.isOutput)
              ? _uniqueRowChilds.size === 1
              : false;  
              // console.log('[AudienceWidget] isOutput:', this.isOutput, 'audienceAllSamePrefix:', _audienceAllSamePrefix, 'uniqueRowChildren:', [...new Set((lev2.data||[]).map((d:any)=>d.rowChild))]);
            const _hasMultipleAudiences = (this.isAudienceSnapshot && !this._configService.multiCohort && this.isOutput)
              ? _uniqueColChilds.size > 1
              : false;
              const hasPercentageExtension =
  lev2.extensionOptions?.some(
    (e: any) =>
      e.id === 'percentageSymbol' &&
      e.selected
  ) || false;
            lev2.data.forEach((dataArr: any) => {
              const _colChildLabel = (col: string) => col?.includes('|')
                ? col.split('|')[col.split('|').length - 1].trim()
                : col;
              let d1 = {
              'Series Name': this.isAudienceSnapshot
  ? (
      this._configService.multiCohort
        ? (
            dataArr.colChild?.split('|').length === 3 &&
            dataArr.colChild?.split('|')[0]?.trim().toLowerCase() === 'audience'
              ? dataArr.colChild.split('|')[2].trim() // or [2] depending on requirement
              : this.getAudienceDisplayLabel(dataArr.colChild, [])
          )
        : (_hasMultipleAudiences            
            ? (_audienceAllSamePrefix ? _colChildLabel(dataArr.colChild) : _colChildLabel(dataArr.colChild) + ' | ' + dataArr.rowChild)           
            : dataArr.rowChild)
    )
  : this._configService.selectedSnapshotType.toLowerCase().includes('multi')
      ? (
        dataArr.colChild
      )
      : dataArr.rowChild,
               // 'Series Name': this._configService.selectedSnapshotType.toLowerCase().includes("multi") ? dataArr.colChild : dataArr.rowChild,
                'Category Name': dataArr.lvl1Child.replace(/^(Month|Year|Quarter)\|/, ''),
                'Rounded Value':
                  dataArr.data == null
                    ? null
                    : dataArr.CalculationType?.toLowerCase() == 'share' ||
                      dataArr.CalculationType?.toLowerCase() == 'respgrp'
                      ? dataArr.data * 100
                      : dataArr.data,
                'Value':
                  dataArr.CalculationType?.toLowerCase() == 'share' ||
                    dataArr.CalculationType?.toLowerCase() == 'respgrp'
                    ? dataArr.data * 100
                    : dataArr.data,
                "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
                "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
                'Label':
                  dataArr.data == null
                    ? 'NA'
                    : dataArr.CalculationType?.toLowerCase() == 'share' ||
                      dataArr.CalculationType?.toLowerCase() == 'respgrp'
                      ? dataArr.data * 100
                      : dataArr.data,
                'ChangeVs': isTotalBase ? dataArr.changeVsPY_Total :dataArr.changeVsPY_Answer,
                'Significance': '-1',
                'Sample size':  this._configService.baseSelected.toLowerCase() == 'total base'
                        ? dataArr.totalUnweightedBase
                        : dataArr.answerUnweightedBase,
                'Significance2': '1',
                'Category Image': 'Category_Image_1',
                // 'isPercentage':
                //   dataArr.CalculationType?.toLowerCase() == 'share' ||
                //     dataArr.CalculationType?.toLowerCase() == 'respgrp'
                //     ? true
                //     : false,
                "isPercentage":
                  (dataArr.CalculationType?.toLowerCase() === "share" ||
                    dataArr.CalculationType?.toLowerCase() === "respgrp" ||
                    dataArr.CalculationType?.toLowerCase() === "meanpercentage"
                  )
                    ? true
                    : (hasPercentageExtension === true ? false : hasPercentageExtension === null ? false : true),
                'Sig_LowerLimt': this.Sig_LowerLimt,
                'Sig_UpperLimt': this.Sig_UpperLimt,
                 'color': dataArr.color,
                "Significance_Value": isTotalBase ? dataArr.Significance_Total : dataArr.Significance_Answer,
                'isAdditionalKPI': dataArr.isAdditionalKPI ?? false
              };
              this.chartMainData.push(d1);
            });
          }
        }
      });
    })
    // this.chartMainData=this.chartMainData.slice(0,1);
  }

  commonfunc(event: any, customization: string, options: any) {
    this.event = event;
    this.ChartProperties = this.LineTrendService.commonFunc(customization, event, this.ChartProperties)
    this.plotLineChart('chart-container');
  }

  plotyaxis() {
    if (
      this.ChartProperties.stacking == 1 ||
      this.ChartProperties.stacking == 2
    ) {
      return {
        title: {
          text: '',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },

        gridLineWidth: this.ChartProperties.gridlines,
        labels: {
          rotation: this.LineTrendService.axisLabelOrientation(
            this.ChartProperties.yaxisLabelOrientation
          ),
          format:
            this.ChartProperties.datalabelFormat == 'number'
              ? '{value}'
              : '{value}%',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },
      };
    } else {
      // return {
      //   title: {
      //     text: '',
      //     style: {
      //       color: this.ChartProperties.darkTheme ? 'white' : 'Black',
      //     },
      //   },
      //   min: this.showLowSample ? 0 : this.chartMinAxis,
      //   // max: this.chartMaxAxis > 100 ? 100 : this.chartMaxAxis,
      //   max: this.chartMaxAxis,
      //   gridLineWidth: this.ChartProperties.gridlines,
      //   labels: {
      //     rotation: this.LineTrendService.axisLabelOrientation(
      //       this.ChartProperties.yaxisLabelOrientation
      //     ),
      //     format:
      //       this.ChartProperties.datalabelFormat == 'number'
      //         ? '{value}'
      //         : '{value}%',
      //     style: {
      //       color: this.ChartProperties.darkTheme ? 'white' : 'Black',
      //     },
      //   },
      // };
      return {
        title: {
          text: '',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },
        min: this.showLowSample ? 0 : this.chartMinAxis,
        max: this.chartMaxAxis,
        tickInterval: 10, // Set the tick interval to always be 10
        gridLineWidth: this.ChartProperties.gridlines,
        labels: {
          rotation: this.LineTrendService.axisLabelOrientation(
            this.ChartProperties.yaxisLabelOrientation
          ),
          format:
            this.ChartProperties.datalabelFormat == 'number'
              ? '{value}'
              : '{value}%',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },
      }
      
    }
  }

  plotLineChart(containerId: any) {
    if (this.isOutput) {
      localStorage.setItem('properties', JSON.stringify(this.ChartProperties));
      this.prepareSeriesDataForChart();
      const seriesGroups = _.groupBy(this.chartMainData, 'Series Name');
      const validSeriesNames = Object.keys(seriesGroups).filter(seriesName =>
        seriesGroups[seriesName].some((d: any) => d['Label'] !== 'NA' && d['Label'] !== null && d['Label'] !== undefined)
      );
      this.chartMainData = this.chartMainData.filter((d: any) => validSeriesNames.includes(d['Series Name']));
      if (this.chartMainData.length === 0) {
        const containerEl = document.getElementById(containerId);
        if (containerEl) {
          containerEl.innerHTML = '<div style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size: 0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>';
        }
        return;
      }
      let properties = this.ChartProperties;
      let samplesizeConstantValue = this._configService.ISthreshold;
      //const updatedCategoryNames = this.LineTrendService.updatedCategories.map(category => category.image);
      //let updatedCategories = this.LineTrendService.updatedCategories;
      let ispercentage = false;
      let that = this;
      let colors = this.colorCodeList;
      if (this.ChartProperties.datalabelFormat === 'percentage') {
        ispercentage = true;
      }

      if (
        this.ChartProperties.stacking == 1 ||
        this.ChartProperties.stacking == 2
      ) {
        this.seriesData.reverse();
      }

      let configService = this._configService;

      const containerEl = document.getElementById(containerId);
      if (!containerEl) { return; }
      this.chart = new Highcharts.Chart(containerEl, {
        chart: {
          type: 'line',
          marginLeft: 40,
          marginRight: 15,
          marginTop: 30,
          animation: false,
          backgroundColor: this.ChartProperties.darkTheme ? 'Black' : 'white',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
            fontFamily: 'KantarBrown-Regular',
            fontSize: '0.7rem'
          },
           zoomType: 'xy'
        },
        title: {
          text: '',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
          align: this.ChartProperties.chartTitlePosition,
        },
        credits: {
          enabled: false,
        },
        yAxis: this.plotyaxis(),
        xAxis: {
          title: {
            text: '',
            style: {
              fontSize: '12px',
              color: '#E8E8E8',
            },
          },
          // min: 0,
          gridLineWidth: this.ChartProperties.gridlines,
          categories: properties.axisImage
            ? this.updateCategoryName
            : this.categoriesList,
          labels: {
            rotation: this.LineTrendService.axisLabelOrientation(
              this.ChartProperties.axisLabelOrientation
            ),
            style: {
              color: this.ChartProperties.darkTheme ? 'white' : 'Black',
            },
            useHTML: true,
            formatter: function (
              this: Highcharts.AxisLabelsFormatterContextObject
            ) {
              if (properties.axisImage) {
                var index = this.axis.categories.indexOf(String(this.value));
                var category = that.updateCategoryName[index];

                if (category) {
                  return (
                    '<span style="display: inline-block; width: 2em; height: 2em; background: url(../../../../../../assets/Images/LineOrTrendChart/' +
                    category +
                    '.png) no-repeat center center; background-size: cover;"></span>'
                  );
                } else {
                  return '<span>No Image</span>';
                }
              } else {
                return String(this.value);
              }
            },
          },
        },

        tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          shape: properties.toolTipStyle == 'style1' ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',

          formatter: function (this: any) {
            const pointWithMetric = (
              this as Highcharts.TooltipFormatterContextObject
            ).point as {
              name?: any;
              parent?: any;
              color?: any;
              y?: number;
              y1?: number;
              cov?: string;
              significance?: string;
              samplesize?: number;
              significance2?: any;
              tooltip?: any;
              isPercentage?: any;
              Sig_LowerLimt?: any;
              Sig_UpperLimt?: any;
              Significance_Value?: any;
              indexValue?: any
            };

            let roundedValue = this.series.userOptions.data1[this.point.x]['Rounded Value'];
            properties.dataLabelFormat = pointWithMetric.isPercentage;
            if (roundedValue == null && properties.datalabelStyle == 'datalabel') return 'NA';
            if (properties.datalabelStyle === 'index') {

              let finalText: any = roundedValue == null
                ? 'NA'
                : configService.CheckLSorIScondition(
                    configService.userRole,
                    this.y + (this.series.userOptions.data1[this.point.x]['isPercentage'] && '%'),
                    this.series.userOptions.data1[this.point.x]['Sample size']
                  );
              // pointWithMetric.tooltip = finalText;


              let text2 = pointWithMetric.y1 != null ? pointWithMetric.indexValue : 'NA';
              //text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
              let color = configService.CheckIndexColoring(String(text2));
              text2 = `<span style="color: ${color} ;">${text2}</span>`;
              pointWithMetric.tooltip = finalText + "(" + text2 + ")";
              // return (
              //   '<span style="color:' + 'black' + ';">' + text + '</span>'
              // );
            }
            else if (properties.datalabelStyle === 'sigChange') {       
              let changeVal = pointWithMetric.isPercentage
                ? Number(pointWithMetric.cov) * 100
                : Number(pointWithMetric.cov);
              if (
                pointWithMetric.cov == null ||
                pointWithMetric.cov == 'NA'
              ) {
                let text =
                  roundedValue != null
                    ? pointWithMetric.y +
                    (properties.dataLabelFormat ? '%' : '') +
                    ' ' +
                    `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`
                    : 'NA';
                pointWithMetric.tooltip = text;
                // return (
                //   '<span style:"color:' + 'black' + ';">' + text + '</span>'
                // );
              } else {
                let val = pointWithMetric.y != null
                  ? pointWithMetric.y +
                  (properties.dataLabelFormat ? '%' : '') : 'NA';
                // val = configService.CheckLSorIScondition(
                //   configService.userRole,
                //   val,
                //   pointWithMetric.samplesize ? pointWithMetric.samplesize : 0
                // );

                if (val == "I/S") {
                  pointWithMetric.tooltip = val;
                } else {

                  let sigClass =
                    pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt
                      ? 'red'
                      :  pointWithMetric.Significance_Value  > pointWithMetric.Sig_UpperLimt
                        ? 'green'
                        : 'black';
                  let text =
                    roundedValue != null
                      ? pointWithMetric.y +
                      (properties.dataLabelFormat ? '%' : '') +
                      ' ' +
                      `<span style="font-size: 80%;  color: ${sigClass};">(` +
                      `${pointWithMetric.cov != null
                        ? parseFloat(Number(changeVal).toFixed(1)) + (pointWithMetric.isPercentage
                          ? '%' : '')
                        : 'NA'
                      })</span>`
                      : 'NA';
                  pointWithMetric.tooltip = text;
                }
                // return (
                //   '<span style:"color:' + 'black' + ';">' + text + '</span>'
                // );
              }
            }
            else {
              let finalText =
                this.y +
                (this.series.userOptions.data1[this.point.x]['isPercentage'] &&
                  '%');
              finalText = configService.CheckLSorIScondition(
                configService.userRole,
                finalText,
                this.series.userOptions.data1[this.point.x]['Sample size']
              );
              pointWithMetric.tooltip = finalText;
            }


            if (this.series.name === 'Marker1') return false;
            let isDefaultTooltip = properties.toolTipStyle;
            const text = properties.showDataLabel
              ? this.series.userOptions.tooltip[this.point.x]
              : this.y;
            const dotColor = this.series.color;
            const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
            if (isDefaultTooltip == 'style1') {
              const commonContent =
                `<div style="width:120%;border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor}; z-index: 100; padding: 3%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2};">` +
                // `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 1rem;">Tooltip Title</span>` +
                ` ${this.series.userOptions.name}<br>` +
                // `<span><strong>Category Name:</strong></span> ${this.series.userOptions.data1[this.point.x]['Category Name']
                // }<br>` +
                `<span><strong>Value:</strong></span> ${pointWithMetric.tooltip}`;
              return commonContent + '</div>';
            } else {
              // Get the series color
              const content =
                `<div style="background-color: white; padding: 3%; align-items: center; border: 1px solid ${dotColor};min-width:120%;">` +
                `<div style="display:flex"><div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%;"> </div>` +
                `<div style="width:90%; padding-left:5%;"> ${this.series.name} </div></div>` +
                `<div style="display: block; margin-top: 1%; margin-left:12%;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;
              return content + '</div>';
            }
          },
        } as any,
        // legend: this.LineTrendService.customizeLegend(properties.showLegend, properties.legendPosition, this.ChartProperties.darkTheme, this.ChartProperties.stacking),
        legend: {
          enabled: true,
          events: {
            itemHover: function (event: any) {
              // Display tooltip when hovering over legend item
              const point = event.target;
              const tooltip = document.createElement('div');
              tooltip.className = 'custom-tooltip';
              tooltip.style.position = 'absolute';
              tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
              tooltip.style.color = 'white';
              tooltip.style.padding = '5px';
              tooltip.style.borderRadius = '3px';
              tooltip.style.pointerEvents = 'none';
              tooltip.innerText = point.name;
              document.body.appendChild(tooltip);

              // Position tooltip
              document.addEventListener('mousemove', function (e) {
                tooltip.style.left = e.pageX + 10 + 'px';
                tooltip.style.top = e.pageY + 10 + 'px';
              });
            },
            itemMouseOut: function (event: any) {
              // Remove tooltip when mouse leaves legend item
              const tooltip = document.querySelector('.custom-tooltip');
              if (tooltip) {
                tooltip.remove();
              }
            },
          },
          // reversed: (this.ChartProperties.stacking == 1 || this.ChartProperties.stacking == 2) ? true : false,
          align: 'center',
          verticalAlign: 'bottom',
          layout: 'horizontal',
          maxHeight: 120, // Limit legend height, enables Highcharts pagination
          itemStyle: {
            fontWeight: 'normal',
            fontSize: this.height != '100%' ? '0.8em' : '1em',
            cursor: 'pointer',
          },
          useHTML: true,
          // symbolWidth: -1,
          // symbolHeight: -1,
          labelFormatter: function (): any {
            let point = this as any;
            // let textcolor = chartproperties.darkTheme ? 'white' : 'black';
            if (point.color != '#eeebed' && point.color != '#7f7f7f') {
              return (
                '<div style="display:flex;align-items:center;font-size:0.7em;" title="' +
                point.name +
                '">' +
                '<div style="display:flex;width:9px;height:9px;background-color:' +
                point.legendkeycolor +
                ';border-radius:50%;"></div>' +
                '<div style="z-index: 10000; height: 18px; padding-left: 8px; padding-top: 1%; color: black; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; flex: 1; font: KantarBrown-Regular; cursor: pointer;" title="' +
                point.name +
                '">' +
                '   ' +
                point.name +
                '   ' +
                '</div>' +
                '</div>'
              );
            }
          },
        },
        plotOptions: {
          series: {
            animation: false,
          },
          line: {
            stacking:
              this.ChartProperties.stacking == 0
                ? ''
                : this.ChartProperties.stacking == 1
                  ? 'normal'
                  : 'percent',
            lineWidth: properties.lineWidth || 2,  //2 for visible lines
            dashStyle: properties.gridLineDashStyle,
            fillOpacity: 0.4,
            marker: {
              enabled: true,
              symbol: properties.markerStyle,
              radius: 4,
              lineWidth: properties.markerLineWidth,
            },
            dataLabels: {
              enabled: this.DataLabelOn,
              allowOverlap: true,
              align:
                properties.dataLabelPosition == 'left'
                  ? 'right'
                  : properties.dataLabelPosition == 'right'
                    ? 'left'
                    : 'center',
              rotation: properties.datalabelOrientation,
              backgroundColor: 'transparent',
              color: properties.darkTheme
                ? properties.dataLabelColor === 'default'
                  ? 'white'
                  : properties.dataLabelColor
                : properties.dataLabelColor === 'default'
                  ? 'black'
                  : properties.dataLabelColor,
              style: {
                fontSize: properties.dataLabelSize,
                textOutline: 'none',
                fontWeight: 'normal',
              },
              formatter: function (this: any) {
                const pointWithMetric = (
                  this as Highcharts.TooltipFormatterContextObject
                ).point as {
                  name?: any;
                  parent?: any;
                  color?: any;
                  y?: number;
                  y1?: number;
                  cov?: string;
                  significance?: string;
                  samplesize?: number;
                  significance2?: any;
                  tooltip?: any;
                  isPercentage?: any;
                  Sig_LowerLimt?: any;
                  Sig_UpperLimt?: any;
                  Significance_Value?: any;
                  indexValue?: any
                };
                const upwardTriangle = '&#9650';
                const downwardTriangle = '\u25BC';
                // let roundedValue =
                //   this.series.userOptions.data1[this.point.x]['Rounded Value'];
                // properties.dataLabelFormat = pointWithMetric.isPercentage;
                const sourceData =
                  this.series.userOptions.data1?.[this.point.x];

                if (!sourceData) {
                  return null;
                }

                const roundedValue = sourceData['Rounded Value'];
                const isPercentage = Boolean(sourceData['isPercentage']);
                const sampleSize = sourceData['Sample size'];
                if (roundedValue == null && properties.datalabelStyle == 'datalabel') return 'NA';                
                if (properties.datalabelStyle === 'index') {

                  let finalText: any = roundedValue == null
                    ? 'NA'
                    : configService.CheckLSorIScondition(
                        configService.userRole,
                        this.y + (this.series.userOptions.data1[this.point.x]['isPercentage'] && '%'),
                        this.series.userOptions.data1[this.point.x]['Sample size']
                      );
                    pointWithMetric.tooltip = finalText;
      
    
                  let text2 = pointWithMetric.y1 != null ? pointWithMetric.indexValue : 'NA';
                  //text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
                  let color = configService.CheckIndexColoring(String(text2));
                  text2 = `<span style="color: ${color} ;">${text2}</span>`;
                  pointWithMetric.tooltip =finalText+ "("+text2+")";
                  return (
                    '<span style="color:' + 'black' + ';">' + finalText+ "("+text2+")" + '</span>'
                  );
                }
  
                if (properties.datalabelStyle === 'sigChange') {                
                  let changeVal = pointWithMetric.isPercentage
                    ? Number(pointWithMetric.cov) * 100
                    : Number(pointWithMetric.cov);
                  if (
                    pointWithMetric.cov == null ||
                    pointWithMetric.cov == 'NA'
                  ) {
                    let text =
                      roundedValue != null
                        ? pointWithMetric.y +
                        (properties.dataLabelFormat ? '%' : '') +
                        ' ' +
                        `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`
                        : 'NA';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style:"color:' + 'black' + ';">' + text + '</span>'
                    );
                  } else {

                    let val = pointWithMetric.y != null
                      ? pointWithMetric.y +
                      (properties.dataLabelFormat ? '%' : '') : 'NA';
                    // val = configService.CheckLSorIScondition(
                    //   configService.userRole,
                    //   val,
                    //   pointWithMetric.samplesize ? pointWithMetric.samplesize : 0
                    // );

                    if (val == "I/S") {
                      return (
                        '<span style:"color:' + 'black' + ';">' + val + '</span>'
                      );
                    }

                    let sigClass =
                       pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt
                        ? 'red'
                        : pointWithMetric.Significance_Value > pointWithMetric.Sig_UpperLimt
                          ? 'green'
                          : 'black';


                    let text =
                      roundedValue != null
                        ? pointWithMetric.y +
                        (properties.dataLabelFormat ? '%' : '') +
                        ' ' +
                        `<span style="font-size: 80%;  color: ${sigClass};">(` +
                        `${pointWithMetric.cov != null
                          ? parseFloat(Number(changeVal).toFixed(1)) + (pointWithMetric.isPercentage
                            ? '%' : '')
                          : 'NA'
                        })</span>`
                        : 'NA';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style:"color:' + 'black' + ';">' + text + '</span>'
                    );
                  }
                }
                let finalText =
                  this.y +
                  (this.series.userOptions.data1[this.point.x]['isPercentage'] &&
                    '%');
                finalText = configService.CheckLSorIScondition(
                  configService.userRole,
                  finalText,
                  this.series.userOptions.data1[this.point.x]['Sample size']
                );
                pointWithMetric.tooltip = finalText;
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
                // if (properties.datalabelStyle == "significance + changeVs") {
                //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%');
                //   changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
                //   let sig = this.series.userOptions.data1[this.point.x]["Significance"];
                //   let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                //   let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                //   let finalText = '<span>' + text +
                //     (changeText ? '&nbsp;<span>' +
                //       '' + `<span style="font-size: 80%; color:${properties.darkTheme ? "white" : "black"}">(` + changeText + ')</span>' + '&nbsp;' +
                //       '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                //     '</span>';
                //   this.series.userOptions.tooltip[this.point.x] = finalText;

                //   return (
                //     finalText
                //   );
                // }

                // if (properties.datalabelStyle == "change") {
                //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%')
                //   //text = this.y != 0 ? this.y + ( ispercentage && '%' ) : 'NA';
                //   changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
                //   let finalText = '<span>' + text + '' +
                //     (changeText ? `<span style="font-size: 80%; color:${properties.darkTheme ? "white" : "black"}">(` + changeText + ')</span>' : '') +
                //     '</span>'
                //   this.series.userOptions.tooltip[this.point.x] = finalText;
                //   return (
                //     finalText
                //   );
                // }

                // if (properties.datalabelStyle == "significance") {
                //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%');
                //   // text = this.y != 0 ? this.y + ( ispercentage && '%' ) : 'NA';
                //   let sig = this.series.userOptions.data1[this.point.x]["Significance"];
                //   let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                //   let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                //   let finalText = '<span >' + text + '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span></span>';
                //   this.series.userOptions.tooltip[this.point.x] = finalText;
                //   return (
                //     finalText
                //   );
                // }

                // if (properties.datalabelStyle == "significance2") {
                //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%');
                //   changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
                //   let sig = this.series.userOptions.data1[this.point.x]["Significance"];
                //   let sig1 = this.series.userOptions.data1[this.point.x]["Significance2"];
                //   let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                //   let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? "white" : "Black");
                //   let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                //   let finalText = '<span>' + text +
                //     (changeText ? '&nbsp<span style="color:' + ';"> ' +
                //       '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                //       '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                //     '</span>';
                //   this.series.userOptions.tooltip[this.point.x] = finalText;
                //   return (
                //     finalText
                //   );
                // }

                // if (properties.datalabelStyle == "ls") {
                //   text = this.series.userOptions.data1[this.point.x]["Sample size"] >= samplesizeConstantValue ? this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%') : 'LS';
                //   let finalText = '<b>' +
                //     text +
                //     '</b> ' +
                //     '<span style="opacity: 0.5"></span>';
                //   this.series.userOptions.tooltip[this.point.x] = finalText;
                //   return (
                //     finalText
                //   );
                // }
              },
            },
          },
        },
        series: this.seriesData,
      } as any);

      // Legend is always at bottom in output mode; no left/right margin adjustments needed

    }
    else {
      localStorage.setItem("properties", JSON.stringify(this.ChartProperties));
      this.prepareSeriesDataForChart();
      const seriesGroups = _.groupBy(this.chartMainData, 'Series Name');
      const validSeriesNames = Object.keys(seriesGroups).filter(seriesName =>
        seriesGroups[seriesName].some((d: any) => d['Label'] !== 'NA' && d['Label'] !== null && d['Label'] !== undefined)
      );
      this.chartMainData = this.chartMainData.filter((d: any) => validSeriesNames.includes(d['Series Name']));
      if (this.chartMainData.length === 0) {
        const containerEl = document.getElementById(containerId);
        if (containerEl) {
          containerEl.innerHTML = '<div style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size: 0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>';
        }
        return;
      }
      let properties = this.ChartProperties;
      let samplesizeConstantValue = this.samplesizeConstantValue;
      //const updatedCategoryNames = this.LineTrendService.updatedCategories.map(category => category.image);
      //let updatedCategories = this.LineTrendService.updatedCategories;
      let ispercentage = false;
      let that = this;
      let colors = this.colorCodeList;
      if (this.ChartProperties.datalabelFormat === "percentage") {
        ispercentage = true;
      }

      if (this.ChartProperties.stacking == 1 || this.ChartProperties.stacking == 2) {
        this.seriesData.reverse();
      }
      const containerEl = document.getElementById(containerId);
      if (!containerEl) { return; }
      this.chart = new Highcharts.Chart(containerEl, {
        chart: {
          type: 'line',
          marginLeft: 40,
          marginRight: 15,
          marginTop: 30,
          backgroundColor: this.ChartProperties.darkTheme ? "Black" : "white",
          zooming: {
            type: 'xy'
          },
          style: {
            color: this.ChartProperties.darkTheme ? "white" : "Black",
          },

        },
        title: {
          text: "",
          style: {
            color: this.ChartProperties.darkTheme ? "white" : "Black",
            fontFamily: 'KantarBrown-Regular'
          },
          align: this.ChartProperties.chartTitlePosition,
        },
        credits: {
          enabled: false
        },
        yAxis: this.plotyaxis(),
        xAxis: {
          title: {
            text: '',
            style: {
              fontSize: '12px',
              color: '#E8E8E8'
            }
          },
          // min: 0,
          gridLineWidth: this.ChartProperties.gridlines,
          categories: properties.axisImage ? this.updateCategoryName : this.categoriesList,
          labels: {
            rotation: this.LineTrendService.axisLabelOrientation(this.ChartProperties.axisLabelOrientation),
            style: {
              color: this.ChartProperties.darkTheme ? "white" : "Black"
            },
            useHTML: true,
            formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
              if (properties.axisImage) {
                var index = this.axis.categories.indexOf(String(this.value));
                var category = that.updateCategoryName[index];

                if (category) {
                  return '<span style="display: inline-block; width: 2em; height: 2em; background: url(../../../../../../assets/Images/LineOrTrendChart/' + category + '.png) no-repeat center center; background-size: cover;"></span>';
                } else {
                  return '<span>No Image</span>';
                }
              } else {
                return String(this.value);
              }
            },
          }
        },

        tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          shape: properties.toolTipStyle == "style1" ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',

          formatter: function () {
            if (this.series.name === 'Marker1') return false;
            let isDefaultTooltip = properties.toolTipStyle;
            const text = properties.showDataLabel ? this.series.userOptions.tooltip[this.point.x] : this.y;
            const dotColor = this.series.color;
            const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
            if (isDefaultTooltip == "style1") {
              const commonContent =
                `<div style="width:120%;border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 3%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2};">` +
                `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 1rem;">Tooltip Title</span>` +
                `<span><strong>Series Name:</strong></span> ${this.series.userOptions.name}<br>` +
                `<span><strong>Category Name:</strong></span> ${this.series.userOptions.data1[this.point.x]["Category Name"]}<br>` +
                `<span><strong>Value:</strong></span> ${text}`;
              return commonContent + '</div>';
            }
            else {

              // Get the series color
              const content =
                `<div style="background-color: ${backgroundcolor}; padding: 10%; align-items: center; border: 1px solid ${dotColor}; width:120%">` +
                `<div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%; margin-right: 5%;"> </div>` +
                ` ${this.series.name}` +
                `<div style="display: block; margin-top: 1%;"><strong>Value:</strong> ${text}</div>`;
              return content + '</div>';
            }
          },
        } as any,
        legend: this.LineTrendService.customizeLegend(properties.showLegend, properties.legendPosition, this.ChartProperties.darkTheme, this.ChartProperties.stacking),
        plotOptions: {
          series: {
            animation: false
          },
          line: {
            stacking: this.ChartProperties.stacking == 0 ? "" : (this.ChartProperties.stacking == 1 ? "normal" : "percent"),
            lineWidth: properties.lineWidth || 2,
            dashStyle: properties.gridLineDashStyle,
            fillOpacity: 0.4,
            marker: {
              enabled: true,
              symbol: properties.markerStyle,
              radius: 4,
              lineWidth: properties.markerLineWidth,
            },
            dataLabels: {
              enabled: properties.showDataLabel,
              allowOverlap: true,
              align: properties.dataLabelPositionPPT == "left" ? "right" : (properties.dataLabelPositionPPT == "right" ? "left" : "center"),
              rotation: properties.datalabelOrientation,
              backgroundColor: 'transparent',
              color: properties.darkTheme ? (properties.dataLabelColor === 'default' ? 'white' : properties.dataLabelColor)
                : (properties.dataLabelColor === 'default' ? 'black' : properties.dataLabelColor),
              style: {
                fontSize: properties.dataLabelSize,
                textOutline: 'none',
                fontWeight: "normal",
              },
              formatter: function (this: any) {
                const upwardTriangle = '&#9650';
                const downwardTriangle = '\u25BC';
                let text;
                let changeText;
                let roundedValue = this.series.userOptions.data1[this.point.x]["Rounded Value"];
                if (roundedValue == null) {
                  this.series.userOptions.tooltip[this.point.x] = "NA";
                  return "NA";
                }

                if (properties.datalabelStyle == "sigchan") {
                  text = this.y + (ispercentage && '%');
                  changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
                  let sig = this.series.userOptions.data1[this.point.x]["Significance"];
                  let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                  let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                  let finalText = '<span>' + text +
                    (changeText ? '&nbsp;<span>' +
                      '' + `<span style="font-size: 80%; color:${properties.darkTheme ? "white" : "black"}">(` + changeText + ')</span>' + '&nbsp;' +
                      '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;

                  return (
                    finalText
                  );
                }

                if (properties.datalabelStyle == "change") {
                  text = this.y + (ispercentage && '%')
                  //text = this.y != 0 ? this.y + ( ispercentage && '%' ) : 'NA';
                  changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
                  let finalText = '<span>' + text + '' +
                    (changeText ? `<span style="font-size: 80%; color:${properties.darkTheme ? "white" : "black"}">(` + changeText + ')</span>' : '') +
                    '</span>'
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return (
                    finalText
                  );
                }

                if (properties.datalabelStyle == "significance") {
                  text = this.y + (ispercentage && '%');
                  // text = this.y != 0 ? this.y + ( ispercentage && '%' ) : 'NA';
                  let sig = this.series.userOptions.data1[this.point.x]["Significance"];
                  let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                  let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                  let finalText = '<span >' + text + '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span></span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return (
                    finalText
                  );
                }

                if (properties.datalabelStyle == "significance2") {
                  text = this.y + (ispercentage && '%');
                  changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
                  let sig = this.series.userOptions.data1[this.point.x]["Significance"];
                  let sig1 = this.series.userOptions.data1[this.point.x]["Significance2"];
                  let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                  let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? "white" : "Black");
                  let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                  let finalText = '<span>' + text +
                    (changeText ? '&nbsp<span style="color:' + ';"> ' +
                      '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                      '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return (
                    finalText
                  );
                }

                if (properties.datalabelStyle == "lowSample") {
                  text = this.series.userOptions.data1[this.point.x]["Sample Size"] >= samplesizeConstantValue ? this.y + (ispercentage && '%') : 'LS';
                  let finalText = '<b>' +
                    text +
                    '</b> ' +
                    '<span style="opacity: 0.5"></span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return (
                    finalText
                  );
                }
                let finalText = this.y + (ispercentage && '%')
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }
            }
          }
        },
        series: this.seriesData,
      } as any);

      // Legend is now at bottom - no additional margin adjustments needed
    }
  }

  // getTooltipValue(value:any,actualValue:any,sampleSize:any){
  //   if(sampleSize >= 1000){
  //     return actualValue == null ? 'NA' : value; 
  //   }
  //   return actualValue == null ? 'NA' : "LS";
  // }
  // prepareSeriesDataForChart() {
  //   if (this.isOutput) {
  //     this.seriesData = [];

  //     this.LineChartData = this.chartMainData;

  //     let metrics = _.uniqBy(this.LineChartData, 'Series Name').map((item) => {
  //       return item['Series Name'];
  //     });

  //     this.categoriesList = _.uniqBy(this.LineChartData, 'Category Name').map(
  //       (item) => {
  //         return item['Category Name'];
  //       }
  //     );

  //     let uniqueDataValue = _.uniqBy(this.LineChartData, 'Rounded Value').map(
  //       (item) => {
  //         return item['Rounded Value'];
  //       }
  //     );

  //     if (this.ChartProperties.datalabelStyle === 'lowSample') {
  //       this.showLowSample = true;
  //     } else {
  //       this.showLowSample = false;
  //     }

  //     let minValue = Math.min(...uniqueDataValue);
  //     let maxValue = Math.max(...uniqueDataValue);
  //     this.chartMinAxis = minValue;
  //     this.chartMaxAxis = maxValue + maxValue * 0.05;

  //     let idx = 0;
  //     let dataObject: any = {};
  //     let consumableData: any = [];
  //     let consumableData1: any = [];

  //     metrics.forEach((metric) => {
  //       dataObject = {};
  //       consumableData = [];
  //       consumableData1 = [];

  //       //let metricData = this.LineChartData.filter( res => res["Series Name"] == metric);
  //       let i = 0;
  //       this.categoriesList.forEach((item: any) => {
  //         let metricData: any;
  //         metricData = this.LineChartData.filter(
  //           (res) => res['Series Name'] == metric && res['Category Name'] == item
  //         )[0];
  //         if (!this.updateCategoryName.includes(metricData['Category Image'])) {
  //           this.updateCategoryName.push(metricData['Category Image']);
  //         }

  //         if (this.showLowSample) {
  //           if (metricData['Sample size'] < this._configService.ISthreshold) {
  //             consumableData.push({
  //               y: 0,

  //             });
  //           } else {
  //             consumableData.push({
  //               y:
  //                 metricData['Value'] == null
  //                   ? null
  //                   : Number(
  //                     parseFloat(metricData['Value']).toFixed(
  //                       this.ChartProperties.decimalRoundOff
  //                     )
  //                   ),
  //               indexValue: metricData['ValueForIndex'] == null
  //                 ? null
  //                 : Number(
  //                   parseFloat(metricData['ValueForIndex']).toFixed(
  //                     this.ChartProperties.decimalRoundOff
  //                   )
  //                 )
  //             });
  //           }
  //         } else {
  //           if (
  //             this._configService.userRole != 'superadmin' &&
  //             metricData['Sample size'] < this._configService.ISthreshold
  //           ) {
  //             consumableData.push({
  //               y: 0,
  //               cov: "I/S",
  //             });
  //           } else {
  //             consumableData.push({
  //               name: metric,
  //               y:
  //                 metricData['Value'] == null
  //                   ? null
  //                   : Number(
  //                     parseFloat(metricData['Value']).toFixed(
  //                       this.ChartProperties.decimalRoundOff
  //                     )
  //                   ),
  //               y1:
  //                 metricData['Value'] == null
  //                   ? null
  //                   : Number(
  //                     parseFloat(metricData['Value']).toFixed(
  //                       this.ChartProperties.decimalRoundOff
  //                     )
  //                   ),
  //               indexValue: metricData['ValueForIndex'] == null
  //                 ? null
  //                 : Number(
  //                   parseFloat(metricData['ValueForIndex']).toFixed(
  //                     this.ChartProperties.decimalRoundOff
  //                   )
  //                 ),
  //               cov: metricData['ChangeVs'],
  //               significance: metricData['Significance'],
  //               samplesize: metricData['Sample size'],
  //               significance2: metricData['Significance2'],
  //               tooltip: '',
  //               isPercentage: metricData['isPercentage'],
  //               Sig_LowerLimt: metricData['Sig_LowerLimt'],
  //               Sig_UpperLimt: metricData['Sig_UpperLimt'],

  //               // "Series Name": lev2.metricName,
  //               // "Category Name": dataArr.lvl1Child,
  //               // "Rounded Value": dataArr.data == null ? null : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
  //               // "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
  //               // "Label": dataArr.data == null ? "NA" : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
  //               // "ChangeVs": dataArr.changeVsPY,
  //               // "Significance": "-1",
  //               // "Sample size": dataArr.baseValueforLSorIs,
  //               // "Significance2": "1",
  //               // "Category Image": "Category_Image_1",
  //               // "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
  //               // "Sig_LowerLimt": this.Sig_LowerLimt,
  //               // "Sig_UpperLimt": this.Sig_UpperLimt
  //             });
  //           }
  //         }
  //         consumableData1.push(metricData);
  //         i++;
  //       });

  //       dataObject.name = metric;
  //       dataObject.color = this.colorCodeList[idx++];
  //       dataObject.data = consumableData;
  //       dataObject.data1 = consumableData1;
  //       dataObject.connectNulls = false;
  //       dataObject.tooltip = [];
  //       //dataObject.pointPlacement = "on";
  //       this.seriesData.push(dataObject);
  //     });
  //   }
  //   else {
  //     this.seriesData = [];

  //     let metrics = _.uniqBy(this.LineChartData, "Series Name").map(item => {
  //       return item["Series Name"];
  //     });

  //     this.categoriesList = _.uniqBy(this.LineChartData, "Category Name").map(item => {
  //       return item["Category Name"];

  //     })

  //     let uniqueDataValue = _.uniqBy(this.LineChartData, "Value").map(item => {
  //       return item["Value"];
  //     });

  //     if (this.ChartProperties.datalabelStyle === "lowSample") {
  //       this.showLowSample = true;
  //     } else {
  //       this.showLowSample = false;
  //     }

  //     let minValue = Math.min(...uniqueDataValue);
  //     let maxValue = Math.max(...uniqueDataValue);
  //     this.chartMinAxis = Math.floor(minValue - (minValue * 0.10));
  //     this.chartMaxAxis = Math.ceil(maxValue + (maxValue * 0.10));

  //     let idx = 0;
  //     let dataObject: any = {};
  //     let consumableData: any = [];
  //     let consumableData1: any = [];

  //     metrics.forEach((metric) => {
  //       dataObject = {};
  //       consumableData = [];
  //       consumableData1 = [];

  //       //let metricData = this.LineChartData.filter( res => res["Series Name"] == metric);
  //       let i = 0;
  //       this.categoriesList.forEach((item: any) => {
  //         let metricData: any;
  //         metricData = _.cloneDeep(this.LineChartData.filter(res => res["Series Name"] == metric && res["Category Name"] == item)[0]);
  //         metricData["Value"] = metricData["Value"] == null ? 0 : parseFloat(Number(_.cloneDeep(metricData["Value"])).toFixed(this.ChartProperties.decimalRoundOff));
  //         if (!this.updateCategoryName.includes(metricData["Category Image"])) {
  //           this.updateCategoryName.push(metricData["Category Image"]);
  //         }

  //         if (this.showLowSample) {
  //           if (metricData["Sample Size"] < this.samplesizeConstantValue) {
  //             consumableData.push({
  //               y: 0
  //             })
  //           } else {
  //             consumableData.push({
  //               y: metricData["Value"] == null ? 0 : metricData["Value"]
  //             })
  //           }
  //         } else {
  //           consumableData.push({
  //             y: metricData["Value"] == null ? 0 : metricData["Value"]
  //           })
  //         }
  //         consumableData1.push(metricData);
  //         i++;
  //       })

  //       dataObject.name = metric;
  //       dataObject.color = this.colorCodeList[idx++];
  //       dataObject.data = consumableData;
  //       dataObject.data1 = consumableData1;
  //       dataObject.tooltip = [];
  //       //dataObject.pointPlacement = "on";
  //       this.seriesData.push(dataObject);
  //     })
  //   }
  // }

  extractDisplayName(metricName: string): string {
    if (!metricName) return metricName;
    const parts = metricName.split('|');

    if (parts.length <= 1) {
      // No pipe separator, return as-is
      return metricName;
    }

    // Check if the first part is a metric group that should be removed (Familiarity, Imagery)
    const firstPart = parts[0].trim();
    const metricGroupsToRemove = ['Familiarity', 'Imagery'];

    if (metricGroupsToRemove.some(group => firstPart === group)) {
       return parts[parts.length - 1].trim();
    } else {
      return parts.map((p: string) => p.trim()).join(' | ');
    }
  }

  prepareSeriesDataForChart() {
    this.seriesData = [];

    this.LineChartData = this.chartMainData;

    let metrics = _.uniqBy(this.LineChartData, 'Series Name').map((item) => {
      return item['Series Name'];
    });

    this.categoriesList = _.uniqBy(this.LineChartData, 'Category Name').map(
      (item) => {
        return item['Category Name'];
      }
    );

    let uniqueDataValue = _.uniqBy(this.LineChartData, 'Rounded Value').map(
      (item) => {
        return item['Rounded Value'];
      }
    );

    if (this.ChartProperties.datalabelStyle === 'lowSample') {
      this.showLowSample = true;
    } else {
      this.showLowSample = false;
    }

    let minValue = Math.min(...uniqueDataValue);
    let maxValue = Math.max(...uniqueDataValue);
    this.chartMinAxis = minValue;
    this.chartMaxAxis = maxValue + maxValue * 0.05;

    let idx = 0;
    const usedColors = new Set<string>();
    let dataObject: any = {};
    let consumableData: any = [];
    let consumableData1: any = [];

    metrics.forEach((metric) => {
      dataObject = {};
      consumableData = [];
      consumableData1 = [];

      //let metricData = this.LineChartData.filter( res => res["Series Name"] == metric);
      let i = 0;
      this.categoriesList.sort((a: any, b: any) => a - b);
      this.categoriesList.forEach((item: any) => {
        let metricData: any;
        metricData = this.LineChartData.filter(
          (res) => res['Series Name'] == metric && res['Category Name'] == item
        )[0];
        if (!this.updateCategoryName.includes(metricData?.['Category Image'])) {
          this.updateCategoryName.push(metricData?.['Category Image'] ?? null);
        }

        if (this.showLowSample) {
          if ((metricData?.['Sample size'] ?? null) < this._configService.ISthreshold) {
            consumableData.push({
              y: 0,
            });
          } else {
            consumableData.push({
              y: this._configService.userRole != "superadmin" && Number(metricData?.['Sample size'] ?? null) <= this._configService.ISthreshold
                ? 0
                : (!this.showLowSample
                    ? (metricData?.['Value'] ?? null) == null ? 0 : Number(parseFloat(metricData?.['Value']).toFixed(this.ChartProperties.decimalRoundOff))
                    : (parseFloat(metricData?.['Sample size']) > this.samplesizeConstantValue
                        ? (metricData?.['Value'] ?? null) == null ? 0 : Number(parseFloat(metricData?.['Value']).toFixed(this.ChartProperties.decimalRoundOff))
                        : 0)),
              indexValue: (metricData?.['ValueForIndex'] ?? null) == null
                ? 'NA'
                : Number(parseFloat(metricData?.['ValueForIndex']).toFixed(this.ChartProperties.decimalRoundOff))
            });
          }
        } else {
          if (
            this._configService.userRole != 'superadmin' &&
            (metricData?.['Sample size'] ?? null) < this._configService.ISthreshold
          ) {
            consumableData.push({
              y: 0,
              cov: "I/S",
              Significance_Value: metricData?.['Significance_Value'] ?? null,
            });
          } else {
            consumableData.push({
              name: metric,
              y: this._configService.userRole != "superadmin" && Number(metricData?.['Sample size'] ?? null) <= this._configService.ISthreshold
                ? 0
                : (!this.showLowSample
                    ? (metricData?.['Value'] ?? null) == null ? 0 : Number(parseFloat(metricData?.['Value']).toFixed(this.ChartProperties.decimalRoundOff))
                    : (parseFloat(metricData?.['Sample size']) > this.samplesizeConstantValue
                        ? (metricData?.['Value'] ?? null) == null ? 0 : Number(parseFloat(metricData?.['Value']).toFixed(this.ChartProperties.decimalRoundOff))
                        : 0)),
              y1: (metricData?.['Value'] ?? null) == null
                ? null
                : Number(parseFloat(metricData?.['Value']).toFixed(this.ChartProperties.decimalRoundOff)),
              indexValue: (metricData?.['ValueForIndex'] ?? null) == null
                ? 'NA'
                : Number(parseFloat(metricData?.['ValueForIndex']).toFixed(this.ChartProperties.decimalRoundOff)),
              cov: metricData?.['ChangeVs'] ?? null,
              significance: metricData?.['Significance'] ?? null,
              samplesize: metricData?.['Sample size'] ?? null,
              significance2: metricData?.['Significance2'] ?? null,
              tooltip: '',
              color: metricData?.['color'] ?? null,
              isPercentage: metricData?.['isPercentage'] ?? null,
              Sig_LowerLimt: metricData?.['Sig_LowerLimt'] ?? null,
              Sig_UpperLimt: metricData?.['Sig_UpperLimt'] ?? null,
              Significance_Value: metricData?.['Significance_Value'] ?? null,
            });
          }
        }
        consumableData1.push(metricData ?? null);
        i++;
      });

  // Use the helper function to extract the display name without metric group prefix
  dataObject.name = this.extractDisplayName(metric);
  // Extract brand name from metric (after pipe if present)
  // const brandName = metric.includes('|') ? metric.substring(metric.indexOf('|') + 1).trim() : metric.trim();

  let brandName = metric ? metric.trim() : '';
  if (metric && metric.startsWith('brand|')) {
    const parts = metric.split('|');
    if (parts.length > 1 && parts[1].trim()) {
      brandName = parts[1].trim();
    }
  }

  // Use global color map if available for this brand, otherwise use default palette
      const isKPI = consumableData1[0]?.isAdditionalKPI ?? false;
      const apiColor = consumableData1?.[0]?.color;

const isAllMetricsForSelectedBrand = this.brandSelected !== '' && this.brandSelected != null;
const payloadColor = isAllMetricsForSelectedBrand ? null : this.getColorFromTrendSeriesMap(metric, dataObject.name, brandName);
const globalColor = isAllMetricsForSelectedBrand ? null : this.getColorFromGlobalMap(brandName);
const rowColor = isAllMetricsForSelectedBrand ? null : apiColor;

const nextPaletteColor = (): string => {
  const palette = this.colorCodeList || [];
  if (!palette.length) { return ''; }
  let color = palette[idx++ % palette.length];
  let guard = 0;
  while (usedColors.has(color) && guard++ < palette.length) {
    color = palette[idx++ % palette.length];
  }
  return color;
};

let seriesColor = isKPI
  ? '#9e9e9e'
  : (payloadColor || rowColor || globalColor || nextPaletteColor());
// Only de-duplicate fallback colors. Payload/global colors are authoritative and may
// intentionally assign a color that is already present in the popup payload.
if (!isKPI && !payloadColor && !rowColor && !globalColor && usedColors.has(seriesColor)) {
  seriesColor = nextPaletteColor();
}
if (!isKPI && seriesColor) {
  usedColors.add(seriesColor);
}
      dataObject.color = seriesColor;
      dataObject.legendkeycolor = seriesColor;
      dataObject.isAdditionalKPI = isKPI;
      if (isKPI) {
        dataObject.marker = {
          lineColor: '#333333',
          lineWidth: 1,
          fillColor: '#9e9e9e'
        };
      }
      dataObject.data = consumableData;
      dataObject.data1 = consumableData1;
      dataObject.connectNulls = false;
      dataObject.tooltip = [];
      //dataObject.pointPlacement = "on";
      this.seriesData.push(dataObject);
    });
  }

  getDataValue(sampleSize: any, value: any) {

    if (sampleSize >= this.samplesizeConstantValue)
      return value;
    return 0;
  }

  userselectedproperties() {

    let linechartData = {
      data: this.LineChartData,
      Properties: [this.ChartProperties],
      title: this.data.title
    }
    return JSON.stringify(linechartData).toString();
  }
  customization(): Observable<any> {
    // return this.LineTrendService.Line1CustomizationList();
      const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
    return this._customSnapshotService.getChartCustomization("Trend Line", snapshotTypeSelectedName,cohortType);

  }
  private getColorFromGlobalMap(brandName: string): string | null {
  if (!this.globalColorMap) return null;

  // Normalize spaces around pipe separators(' | ') with ('|').
  const normalizedBrand = brandName.toLowerCase().replace(/ \| /g, '|');

  const matchedKey = Object.keys(this.globalColorMap)
    .find(key => {
      const normalizedKey = key.toLowerCase().replace(/ \| /g, '|');
      return normalizedKey.includes(normalizedBrand) ||
             normalizedBrand.includes(normalizedKey);
    });

  return matchedKey ? this.globalColorMap[matchedKey] : null;
}

  private getColorFromTrendSeriesMap(...keys: string[]): string | null {
    const colorMap = this.trendData?.seriesColorMap;
    if (!colorMap) { return null; }

    const normalizeColorKey = (value: string): string =>
      value
        .toLowerCase()
        .split('|')
        .map(part => part.trim())
        .filter(part => part && part !== 'brand' && part !== 'brands')
        .join('|');

    for (const key of keys) {
      if (!key) { continue; }
      if (colorMap[key]) { return colorMap[key]; }

      const normalizedKey = normalizeColorKey(key);
      const matchedKey = Object.keys(colorMap).find(mapKey => {
        const normalizedMapKey = normalizeColorKey(mapKey);
        return normalizedMapKey === normalizedKey ||
          normalizedMapKey.includes(normalizedKey) ||
          normalizedKey.includes(normalizedMapKey);
      });

      if (matchedKey) { return colorMap[matchedKey]; }
    }

    return null;
  }
  applycustomization(event: any, item: string) {
    this.event = event;
    //choose the appropriate customization
    this.LineTrendService.applycustomization(event, item, this.ChartProperties);
    this.plotLineChart('chart-container');
  }
}
